import type { SupportedLocale, LocaleContentMap } from '../i18n.config';
import type { BlogPostContent } from './blog-post.types';

export const BLOG_POST_CONTENT: LocaleContentMap<BlogPostContent> = {
  en: {
    backToBlog: 'Back to Blog',
    relatedArticles: 'Related Articles',
    relatedSubtitle: 'Continue reading more insights on hotel management and technology',
    ctaTitle: 'Ready to Modernise Your Hotel?',
    ctaSubtitle: 'Experience the platform trusted by 2,500+ hotels across 40+ countries. Start your free trial today and see the difference.',
    ctaTrial: 'Start Free Trial',
    ctaBrowse: 'Browse All Articles',
    categories: { guides: 'Guides', industry: 'Industry', product: 'Product', trends: 'Trends' },
  },
  ar: {
    backToBlog: 'العودة إلى المدونة',
    relatedArticles: 'مقالات ذات صلة',
    relatedSubtitle: 'واصل قراءة المزيد من الرؤى حول إدارة الفنادق والتكنولوجيا',
    ctaTitle: 'هل أنت مستعد لتحديث فندقك؟',
    ctaSubtitle: 'اكتشف المنصة التي يثق بها أكثر من ٢,٥٠٠ فندق في أكثر من ٤٠ دولة. ابدأ تجربتك المجانية اليوم.',
    ctaTrial: 'ابدأ التجربة المجانية',
    ctaBrowse: 'تصفح جميع المقالات',
    categories: { guides: 'أدلة', industry: 'الصناعة', product: 'المنتج', trends: 'الاتجاهات' },
  },
  th: {
    backToBlog: 'กลับไปยังบล็อก',
    relatedArticles: 'บทความที่เกี่ยวข้อง',
    relatedSubtitle: 'อ่านข้อมูลเชิงลึกเพิ่มเติมเกี่ยวกับการจัดการโรงแรมและเทคโนโลยี',
    ctaTitle: 'พร้อมที่จะปรับปรุงโรงแรมของคุณหรือยัง?',
    ctaSubtitle: 'สัมผัสแพลตฟอร์มที่โรงแรมกว่า 2,500 แห่งใน 40+ ประเทศไว้วางใจ เริ่มทดลองใช้ฟรีวันนี้',
    ctaTrial: 'เริ่มทดลองใช้ฟรี',
    ctaBrowse: 'ดูบทความทั้งหมด',
    categories: { guides: 'คู่มือ', industry: 'อุตสาหกรรม', product: 'ผลิตภัณฑ์', trends: 'แนวโน้ม' },
  },
  es: {
    backToBlog: 'Volver al Blog',
    relatedArticles: 'Artículos Relacionados',
    relatedSubtitle: 'Siga leyendo más información sobre gestión hotelera y tecnología',
    ctaTitle: '¿Listo para Modernizar su Hotel?',
    ctaSubtitle: 'Descubra la plataforma en la que confían más de 2.500 hoteles en más de 40 países. Comience su prueba gratuita hoy.',
    ctaTrial: 'Comenzar Prueba Gratuita',
    ctaBrowse: 'Ver Todos los Artículos',
    categories: { guides: 'Guías', industry: 'Industria', product: 'Producto', trends: 'Tendencias' },
  },
  fr: {
    backToBlog: 'Retour au Blog',
    relatedArticles: 'Articles Connexes',
    relatedSubtitle: 'Continuez à lire des informations sur la gestion hôtelière et la technologie',
    ctaTitle: 'Prêt à Moderniser Votre Hôtel ?',
    ctaSubtitle: 'Découvrez la plateforme à laquelle font confiance plus de 2 500 hôtels dans plus de 40 pays. Démarrez votre essai gratuit.',
    ctaTrial: 'Démarrer l\'Essai Gratuit',
    ctaBrowse: 'Parcourir Tous les Articles',
    categories: { guides: 'Guides', industry: 'Industrie', product: 'Produit', trends: 'Tendances' },
  },
  de: {
    backToBlog: 'Zurück zum Blog',
    relatedArticles: 'Verwandte Artikel',
    relatedSubtitle: 'Lesen Sie weitere Einblicke in Hotelmanagement und Technologie',
    ctaTitle: 'Bereit, Ihr Hotel zu Modernisieren?',
    ctaSubtitle: 'Entdecken Sie die Plattform, der über 2.500 Hotels in mehr als 40 Ländern vertrauen. Starten Sie Ihre kostenlose Testversion.',
    ctaTrial: 'Kostenlos Testen',
    ctaBrowse: 'Alle Artikel Durchsuchen',
    categories: { guides: 'Leitfäden', industry: 'Branche', product: 'Produkt', trends: 'Trends' },
  },
  ja: {
    backToBlog: 'ブログに戻る',
    relatedArticles: '関連記事',
    relatedSubtitle: 'ホテル管理とテクノロジーに関する詳細情報を読み続ける',
    ctaTitle: 'ホテルの近代化の準備はできていますか？',
    ctaSubtitle: '40か国以上の2,500以上のホテルが信頼するプラットフォームを体験してください。今すぐ無料トライアルを開始しましょう。',
    ctaTrial: '無料トライアルを開始',
    ctaBrowse: 'すべての記事を見る',
    categories: { guides: 'ガイド', industry: '業界', product: '製品', trends: 'トレンド' },
  },
  zh: {
    backToBlog: '返回博客',
    relatedArticles: '相关文章',
    relatedSubtitle: '继续阅读更多关于酒店管理和技术的见解',
    ctaTitle: '准备好升级您的酒店了吗？',
    ctaSubtitle: '体验40多个国家2,500多家酒店信赖的平台。立即开始免费试用。',
    ctaTrial: '开始免费试用',
    ctaBrowse: '浏览所有文章',
    categories: { guides: '指南', industry: '行业', product: '产品', trends: '趋势' },
  },
  hi: {
    backToBlog: 'ब्लॉग पर वापस',
    relatedArticles: 'संबंधित लेख',
    relatedSubtitle: 'होटल प्रबंधन और प्रौद्योगिकी पर और अंतर्दृष्टि पढ़ें',
    ctaTitle: 'अपने होटल को अपग्रेड करने के लिए तैयार हैं?',
    ctaSubtitle: '40+ देशों में 2,500+ होटलों द्वारा विश्वसनीय प्लेटफॉर्म का अनुभव करें। आज ही मुफ़्त ट्रायल शुरू करें।',
    ctaTrial: 'मुफ़्त ट्रायल शुरू करें',
    ctaBrowse: 'सभी लेख ब्राउज़ करें',
    categories: { guides: 'गाइड', industry: 'उद्योग', product: 'उत्पाद', trends: 'रुझान' },
  },
};
